var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GInputFormat',_vm._g(_vm._b({attrs:{"value":_vm.value,"mask":_vm.getMaskOptions},on:{"input":_vm.updateValue},scopedSlots:_vm._u([{key:"right-addon",fn:function(){return [_vm._t("right-addon")]},proxy:true}],null,true)},'GInputFormat',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }